// private data
import { ERequestType, fetchGetHelper, fetchPostHelper, fetchPutHelper } from "../../tools/fetch";

/*************************************
 State
 **/
const state = {
	tags: {},
	unsubscribeInfosSnapShot: null,
	unsubscribeInfosPublicSnapShot: null,
	infos: {},
	isLoaded: false,
};

/*************************************
 Getters
 **/
const getters = {
	getTagByid: (state) => (tagId) => {
		return Object.entries(state.tags).find(([idT, dataT]) => {
			return tagId === dataT.id;
		});
	},
	getAllTagsData: function (state) {
		return state.tags;
	},
	getAllInfos: function (state) {
		return state.infos;
	},
	getInfosIsLoaded: function (state) {
		return state.isLoaded;
	},
};

/*************************************
 Mutations
 **/
const mutations = {
	setTagList(state, dbData) {
		state.tags = dbData;
	},
	setInfos(state, dbData) {
		state.infos = dbData;
	},
	setLoadedState(state, val) {
		state.isLoaded = val;
	},
	resetStore(state) {
		state.tags = {};
		state.isLoaded = false;
		state.unsubscribeInfosSnapShot = null;
		state.unsubscribeInfosPublicSnapShot = null;
	},
};

/*************************************
 Action
 **/
const actions = {
	cleanStore: function ({ state, rootState, commit, dispatch }) {
		commit("resetStore");
	},
	createNewTag: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];

			let newTag = Object.assign({}, payload);
			newTag.restoid = uid;

			// update tag
			fetchPostHelper(ERequestType.TAGS.CREATE, newTag, userDatas.token)
				.then((res) => {
					dispatch("loadInfos");
					resolve(`tag was created${res}`);
				})
				.catch(function (error) {
					console.error("update infos error : ", error);
					reject(error);
				});
		});
	},
	updateInfos: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];

			let infos = payload;
			infos.restoid = uid;

			fetchPutHelper(ERequestType.INFOS.UPDATE, payload, userDatas.token)
				.then((res) => {
					dispatch("loadInfos");
					resolve(`infos was updated${res}`);
				})
				.catch(function (error) {
					console.error("update infos error : ", error);
					reject(error);
				});
		});
	},
	updateReviews: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		return new Promise((resolve, reject) => {
			let userDatas = rootGetters["newUsers/getUser"];
			let uid = rootGetters["newUsers/getUidPublic"];

			let infos = payload;
			infos.restoid = uid;

			fetchPutHelper(ERequestType.INFOS.UPDATEREVIEWS, payload, userDatas.token)
				.then((res) => {
					dispatch("loadInfos");
					resolve(`reviews was updated${res}`);
				})
				.catch(function (error) {
					console.error("update infos error : ", error);
					reject(error);
				});
		});
	},
	async loadInfos({ state, rootState, commit, dispatch, getters, rootGetters }, restoId) {
		let uid = restoId || rootGetters["newUsers/getUidPublic"];

		return new Promise(async (resolve, reject) => {
			resolve(
				new Promise(async (resolve, reject) => {
					// get tags
					await fetchGetHelper(ERequestType.TAGS.GET, `restoid=${uid}`)
						.then((res) => {
							commit("setTagList", res.data);
						})
						.catch(function (error) {
							console.error("get tags error : ", error);
						});

					// get infos
					await fetchGetHelper(ERequestType.INFOS.GET, `restoid=${uid}`)
						.then((res) => {
							commit("setInfos", res.data);
							// set loaded state
							commit("setLoadedState", true);
							resolve();
						})
						.catch(function (error) {
							console.error("get infos error : ", error);
							reject(error);
						});
				}),
			);
		});
	},
	loadPublicInfos: function ({ state, rootState, commit, dispatch, getters, rootGetters }, restoId) {
		dispatch("loadInfos", restoId);
	},
};

/*************************************
 Helpers
 **/

/*************************************
 Export module
 **/
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
